(function Index($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('AgentGoals/index', function onload() {
			loadTabsContent();
		});

		Adzuki.onload('AgentGoals/view', function onload() {
			var id = $('#goal-id').val();
			loadChart(id);
		});
	});

	function loadChart(id) {
		Adzuki.Ajax.get('/AgentGoals/check/' + id)
		.then(function getChartData(response)
		{
			$('#chart').html(response);
		});
	}

	function loadTabsContent()
	{
		Adzuki.Ajax.get('/AgentGoals/customGoals')
			.then(function getCustomGoals(response) {
				$('#custom-goals').html(response);
			}
		);

		if ($('#primary-goals').length > 0) {
			Adzuki.Ajax.get('/PrimaryGoals/goals')
				.then(function getPrimaryGoals(response) {
					$('#primary-goals').html(response);
				}
			);
		}

		if ($('#northstar').length > 0) {
			Adzuki.Ajax.get('/AgentGoals/northStar')
				.then(function northStar(content) {
					$('#northstar').html(content);
				}
			);
		}
	}
}(jQuery, window.Adzuki || {}));
